
class NewProfessionalActivityController {
  public professionalActivity: any;
  public client: any;
  public dropdownOptions: any = {};
  public isLoading: boolean = false;
  public isEditMode: boolean = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit() {
    // Initialize the professional activity object - create a copy to avoid modifying the original
    if (this.professionalActivity) {
      this.professionalActivity = { ...this.professionalActivity }; // Create a shallow copy
      this.isEditMode = this.professionalActivity.id > 0;
    } else {
      this.professionalActivity = {
        id: 0,
        nameId: 0,
        nameOfOrganisation: '',
        periodFrom: '',
        periodTo: '',
        comments: '',
      };
      this.isEditMode = false;
    }
  }

  public saveProfessionalActivity() {
    this.isLoading = true;
    this.$mdDialog.hide(this.professionalActivity);
  }

  public cancel() {
    this.$mdDialog.hide();
  }
}

export const newProfessionalActivityModal: angular.IComponentOptions = {
  template: require('./new-professional-activity.modal.html'),
  controller: NewProfessionalActivityController,
  controllerAs: '$ctrl',
  bindings: {
    professionalActivity: '<',
    client: '<',
    dropdownOptions: '<'
  }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/profile/modals/new-professional-activity.modal.ts